import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CartButtons from '../CartButtons/CartButtons';
import { useNavigate } from 'react-router';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box } from '@mui/material';
import { useAppContext } from '../../contexts/AppContext';

export default function CartList(props) {
  const { products, isFavorite } = props;
  const navigate = useNavigate();
  const { removeFromCart } = useAppContext();
  return (
    <List
      sx={{
        maxWidth: '100%',
        // bgcolor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        mx: 2,
      }}
    >
      {products.map((prod) => {
        return (
          <>
            <ListItem
              alignItems='center'
              sx={{
                bgcolor: 'background.paper',
                borderRadius: 2,
              }}
            >
              <ListItemAvatar>
                <Avatar
                  alt='Remy Sharp'
                  src={prod.image}
                  sx={{
                    width: 65,
                    height: 'auto',
                  }}
                />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <Typography
                    variant='subtitle1'
                    noWrap
                    sx={{ fontWeight: '600', fontSize: '0.9rem' }}
                  >
                    {prod.name}
                  </Typography>
                }
                sx={{ fontWeight: '700', fontSize: '0.9rem', px: 2 }}
                secondary={
                  <React.Fragment>
                    <Typography
                      variant='body2'
                      color='text.secondary'
                      noWrap
                      sx={{ mb: 1 }}
                    >
                      {prod.size}
                    </Typography>
                    {!isFavorite && <CartButtons product={prod} />}
                  </React.Fragment>
                }
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                {!isFavorite && (
                  <HighlightOffIcon
                    color='primary'
                    onClick={() => removeFromCart(prod.id)}
                  />
                )}
                <Typography
                  variant='subtitle1'
                  noWrap
                  sx={{
                    fontWeight: '700',
                    fontSize: '0.9rem',
                    overflow: 'visible',
                  }}
                >
                  ₹{prod.price * prod.quantity}
                </Typography>
              </Box>
            </ListItem>
          </>
        );
      })}
      {products.length > 0 && !isFavorite && (
        <Button
          variant='contained'
          color='primary'
          sx={{ m: 2, lineHeight: 2.2 }}
          onClick={() => navigate('/checkout')}
        >
          Go to Checkout
          <Typography sx={{ ml: 1, fontWeight: '700', fontSize: '0.8rem' }}>
            ₹
            {products
              .reduce((total, prod) => total + prod.price * prod.quantity, 0)
              .toFixed(2)}
          </Typography>
        </Button>
      )}
    </List>
  );
}
